import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgQrCode = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.173 2A2.173 2.173 0 0 0 2 4.173v2.135a.75.75 0 1 0 1.5 0V4.173a.673.673 0 0 1 .673-.673h2.135a.75.75 0 0 0 0-1.5zm2.885 5.73c0-.37.3-.672.673-.672h2.846c.371 0 .673.301.673.673v2.846a.673.673 0 0 1-.673.673H7.73a.673.673 0 0 1-.673-.673zm.673-2.172c-1.2 0-2.173.973-2.173 2.173v2.846c0 1.2.973 2.173 2.173 2.173h2.846c1.2 0 2.173-.973 2.173-2.173V7.731c0-1.2-.973-2.173-2.173-2.173zm9.211-2.808a.75.75 0 0 1 .75-.75h2.135A2.173 2.173 0 0 1 22 4.173v2.135a.75.75 0 0 1-1.5 0V4.173a.673.673 0 0 0-.673-.673h-2.135a.75.75 0 0 1-.75-.75M3.5 17.692a.75.75 0 0 0-1.5 0v2.135A2.173 2.173 0 0 0 4.173 22h2.135a.75.75 0 0 0 0-1.5H4.173a.673.673 0 0 1-.673-.673zm17.75-.75a.75.75 0 0 1 .75.75v2.135A2.173 2.173 0 0 1 19.827 22h-2.135a.75.75 0 0 1 0-1.5h2.135a.673.673 0 0 0 .673-.673v-2.135a.75.75 0 0 1 .75-.75M7.058 15.558a.75.75 0 0 0-1.5 0v2.134c0 .415.335.75.75.75h2.134a.75.75 0 0 0 0-1.5H7.058zm2.057 0a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 .75.75v2.134a.75.75 0 0 1-1.5 0v-1.384H9.865a.75.75 0 0 1-.75-.75m7.193-9.25a.75.75 0 0 0-1.5 0v2.134c0 .415.335.75.75.75h2.134a.75.75 0 0 0 0-1.5h-1.384zm-1.5 4.98a.75.75 0 0 1 .75-.75h2.134a.75.75 0 0 1 .75.75v2.135a.75.75 0 0 1-1.5 0V12.04h-1.384a.75.75 0 0 1-.75-.75m1.5 4.27a.75.75 0 0 0-1.5 0v2.134c0 .415.335.75.75.75h2.134a.75.75 0 0 0 0-1.5h-1.384z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgQrCode;
